module.exports = __webpack_public_path__ + "static/airport-5ef96c1b89d206464b7fe50006527eb1.jpeg";